define('context/utils',['require','backbone','toastr','moment','views/modals/confirm'],function(require) {

    var Backbone = require('backbone');
    var toastr = require('toastr');
    var moment = require('moment');

    var ConfirmModal = require('views/modals/confirm');

    return Backbone.Model.extend({

        stripSlash: function(pathString) {
          if (pathString[0] == '/') {
              return pathString.substring(1);
          }

          return pathString;
        },

        getUrlParameter: function(parameter) {
          var pageURL = window.location.search.substring(1);
          var urlParameters = pageURL.split('&');

          for (var i=0; i<urlParameters.length; i++) {
            var parameterName = urlParameters[i].split('=');
            if (parameterName[0] == parameter) {
              return parameterName[1];
            }
          }

          return null;
        },

        getUrlParameters: function() {
            var pageURL = window.location.search.substring(1);
            var urlParameters = pageURL.split('&');

            var parameters = [];

            for (var i=0; i<urlParameters.length; i++) {
                var parameterValues = urlParameters[i].split('=');

                parameters.push({
                    key: parameterValues[0],
                    value: parameterValues[1]
                });
            }

            return parameters;
        },

        getListItemByAttr: function(list, value, attr) {
            for (var i=0; i<list.length; i++) {
                if (list[i][attr] == value) {
                    return list[i];
                }
            }

            return null;
        },

        getCookie: function(name) {
            var cookieValue = null;
            if (document.cookie && document.cookie !== '') {
                var cookies = document.cookie.split(';');
                for (var i = 0; i < cookies.length; i++) {
                    var cookie = jQuery.trim(cookies[i]);
                    if (cookie.substring(0, name.length + 1) == (name + '=')) {
                        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                        break;
                    }
                }
            }
            return cookieValue;
        },

        getTRYPrice: function(price, addVAT) {
            var vat = parseFloat(App.context.constants.vat);
            var dollar_try = parseFloat(App.context.constants.dollar_try);

            var tryPrice;
            if (addVAT) {
                tryPrice = (price * dollar_try) + (price * dollar_try * vat);
            } else {
                tryPrice = (price * dollar_try);
            }

            return tryPrice;
        },

        getPricingMode: function () {
            if (App.user) {
                if (App.user.get('country_code') == 'TR') {
                    return 'TRY_VAT';
                } else if (App.user.get('country_code') == 'KKTC') {
                    return 'TRY';
                } else {
                    return 'USD';
                }
            } else {
                return 'USD';
            }
        },

        getPaymentCurrency: function () {
            if (App.user.get('country_code') == 'TR' || App.user.get('country_code') == 'KKTC') {
                return 'TRY';
            } else {
                return 'USD';
            }
        },

        getCurrencySign: function(currency) {
            if (currency === 'USD') {
                return '$';
            } else if (currency === 'TRY') {
                return '₺';
            }

            return '$';
        },

        getAmountWithCurrencySign: function(amount, currency) {
            if (currency === 'USD') {
                return '$ ' + amount;
            } else if (currency === 'TRY' || currency === 'TRY_VAT' ) {
                return amount + ' ₺';
            } else if (currency === 'EUR') {
                return amount + ' €';
            }
            return '$ ' + amount;
        },


        getProductCurrency: function (currencyId) {
            if (currencyId == 1) {
                return 'USD';
            } else if (currencyId == 2) {
                return 'EUR';
            } else if (currencyId == 3) {
                return 'TRY';
            }

            return 'USD';
        },

        getProductCurrencySign: function (currencyId) {
            if (currencyId == 1) {
                return '$';
            } else if (currencyId == 2) {
                return '€';
            } else if (currencyId == 3) {
                return '₺';
            }

            return '$';
        },

        getBasketTotal: function(basket, pricingMode) {
            if (pricingMode === 'TRY') {
                return basket.get('products').reduce( function(total, currentProduct){
                    if (currentProduct.product.exchange_currency === 3) {
                        // Product price in TRY
                        return total + (currentProduct.product.effective_price * currentProduct.count);
                    }

                    // Price in USD, get TRY price
                    return total + App.utils.getTRYPrice(currentProduct.product.effective_price * currentProduct.count, false);
                }, 0);
            } else if (pricingMode === 'TRY_VAT') {
                return basket.get('products').reduce( function(total, currentProduct){
                    if (currentProduct.product.exchange_currency === 3) {
                        // Product price in TRY, add VAT
                        var vat = parseFloat(App.context.constants.vat);
                        return total + (currentProduct.product.effective_price * (1+vat) * currentProduct.count);
                    }

                    // Price in USD, get TRY price
                    return total + App.utils.getTRYPrice(currentProduct.product.effective_price * currentProduct.count, true);
                }, 0);
            } else {
                return basket.get('products').reduce( function(total, currentProduct){
                    if (currentProduct.product.exchange_currency === 3) {
                        // Product price in TRY
                        var dollar_try = parseFloat(App.context.constants.dollar_try);
                        return total + ((currentProduct.product.effective_price / dollar_try) * currentProduct.count);
                    }

                    return total + currentProduct.product.effective_price * currentProduct.count;
                }, 0);
            }
        },

        getAvailableWallet: function () {
            if (App.user.get('reseller') || App.user.get('distributor') || App.user.get('country_distributor')) {
                var paymentCurrency = this.getPaymentCurrency();

                return App.user.get('wallets').filter(function (wallet) {
                    return wallet.currency == paymentCurrency && wallet.balance > 0;
                })[0];
            }

            return undefined;
        },

        showMessage: function (messageType, messageText) {
            if (messageType == 'warning') {
                toastr.warning(messageText);
            } else if (messageType == 'success') {
                toastr.success(messageText);
            } else if (messageType == 'error') {
                toastr.error(messageText);
            }
        },

        getWeekStart: function () {
            var date = new Date();
            var day = date.getDay(),
                diff = date.getDate() - day + (day === 0 ? -6:1); // adjust when day is sunday

            return new Date(date.setDate(diff));
        },

        getMonthStart: function () {
            var date = new Date();
            return new Date(date.getFullYear(), date.getMonth(), 1);
        },

        getYearStart: function () {
            var date = new Date();
            return new Date(date.getFullYear(), 0, 1);
        },

        showConfirmModal: function (confirmText, callback) {
            App.modalRegion.show(new ConfirmModal({
                confirmText: confirmText,
                callback: callback
            }));
        },

        showInfoModal: function (title, text) {
            App.modalRegion.show(new ConfirmModal({
                title: title,
                text: text
            }));
        },

        scrollToTop: function () {
            document.body.scrollTop = document.documentElement.scrollTop = 0;
        },

        hideContent: function () {
            $('body').addClass('content-hidden');
        },

        showContent: function () {
            $('body').removeClass('content-hidden');
        },

        convertToTimezone: function (dateText) {
            var date = moment(dateText, 'YYYY-MM-DD HH:mm:ss');
            date.add(-((new Date().getTimezoneOffset()) * 60000), 'ms');
            return date.format("YYYY-MM-DD HH:mm:ss");
        },

        sendParentMessage: function (messageData) {
            if (window !== top) {
                // We have a parent window
                parent.postMessage(messageData, '*');
            }
        },

        isInCSList: function (value, list) {
            list = list || '';
            list = list.split(',');

            // We now have an array
            return list.filter(function (x) {
                    return x == value;
                }).length > 0;
        },

        getContainerHeightWOffset: function (container) {
            return $(window).height() - container.offset().top - 120;
        },

        getUserTypeCode: function (user) {
            if (user.reseller) {
                return 'r';
            } else if (user.customer) {
                return 'c';
            } else if (user.is_staff) {
                return 'a';
            } else {
                return 'n';
            }
        }

    });

});
